module.exports = __webpack_public_path__ + "img/gadgets_data_pressed@3x.5ad57920.png";